import { environment } from '@env/environment';

const excludedUrls = ['/assets/i18n/es.json', '/assets/i18n/en.json', '/assets/i18n/pt.json', `${environment.oneLoginIssuer}.*`];

export const isExcluded = (url: string): boolean => {
  const apiRegex = new RegExp(environment.baseUrl);
  return apiRegex.exec(url) == null || excludedUrls.some((excludedUrl) => new RegExp(excludedUrl).exec(url) != null);
};
